<template>
<div :style="login_cm_bj" style="padding-top:110px;" >
     <!-- <div  style="width: 100%;background-color: rgb(34, 34, 34);height:54px;">
        <span data-v-3c6d3300="" style="margin-left: 20px; float: left;">
            <img data-v-3c6d3300="" src="../assets/img/MKD-logo.png" style="max-height: 50px;cursor:pointer;" @click="toOurWeb()">
          
        </span>
    </div> -->
       <!-- <div style="width:70%;margin:auto;font-size: 1.17em;padding-top:50px;">
        
            <p>Dear Customers,</p> 
            Due to a very high demand to access to our platform, 
            We are sorry to inform you that new requests to access to our service for customers with less than 30 orders per day are currently closed. 
            We are sorry for the inconvenience.
            We're currently creating a new system to allow sellers with less than 30 orders per day to use our service, 
            It should be ready in 2 or 3 months.
            <p>Thank you for your understanding</p>
            <P style="text-align:right;margin-right:170px;">SR Team</P> 
        </div> -->
    <div class="login-container customerLogin">
         <div class="login-opactiy"></div>
          <div class="login-logo-img"> <img src="../assets/img/MKD-logo2.jpg" alt="" @click="toOurWeb()"> </div>
        <el-form  class="login-form resetPwd-form" autoComplete="on" ref="loginForm" label-position="left">
            <div class="title-container">
                <h3 class="title" style="display:inline-block;color:#000;">{{gets('$客户端重置密码')}}</h3>
                <lang-select class="set-language right lan"></lang-select>
            </div>
            <el-form-item :label="gets('$登录名')" style="padding-top:20px;" class="item-width">
              <el-input v-model="userName" :placeholder="gets('$输入{登录名}')" type="text" auto-complete="off" disabled></el-input>
            </el-form-item>
            <!-- <el-form-item :label="gets('$旧密码')" class="item-width">
              <el-input v-model="oldPassword"  :placeholder="gets('$输入{旧密码}')" type="password"></el-input>
            </el-form-item> -->
            <el-form-item :label="gets('$新密码')" class="item-width">
              <el-input v-model="newPassword" :placeholder="gets('$输入{新密码}')" type="password"></el-input>
            </el-form-item>
            <el-form-item :label="gets('$新密码重复')" class="item-width">
              <el-input v-model="RnewPassword" @keyup.enter.native="ChangeUserPassword()" :placeholder="gets('$重复输入{新密码}')" type="password"></el-input>
            </el-form-item>
               
            
           
            
           
            <el-form-item class="customer-btn">
                <el-button type="primary" style="width:100%" @click="ChangeUserPassword">{{gets('$确定')}}</el-button>
                <!-- <el-button @click="Register">{{gets('$注册')}}</el-button> -->
            </el-form-item>
             
        </el-form>

     

    </div>
</div>
</template>
<!--
<template>
    <div>
        <el-select v-model="loginPage.Value" @change="LenChange()">
            <el-option v-for="item in ls" :value="item.Value" :label=" item.Text"></el-option>
        </el-select>
        <div class="container-fluid">
            <div style="margin: 100px auto; width: 500px;">
                <form role="form">
                    <form-group :placeholder="gets('$输入{登录名}')" :j="{rex:'w',tips:'登录名为必填'}" v-model="loginPage.LoginName.value" :error="loginPage.LoginName.error" :labelName="gets('$登录名')"></form-group>
                    <form-group :placeholder="gets('$输入{密码}')" :j="{rex:'w',tips:'密码为必填'}" :error="loginPage.Password.error" v-model="loginPage.Password.value" :labelName="gets('$密码')"></form-group>
                    <el-button @click="login()" class="btn btn-default">{{gets('$登录')}}</el-button>
                </form>
            </div>
        </div>
    </div>
</template>
-->
<script>
    import SIdentify  from '../components/verificationCode'
    import {
        languageRequest
    } from '../request/language'
    import {
        userRequest
    } from '../request/user.js'
    import {
        ToComponentData,
        CheckByConfig,
        ToSubmitData
    } from '../config/config.js'
    import {
        LoginPage
    } from '@/config/Sys/userConfig.js'
    import gets from '@/model/language'
    //Check() {
    //         ObjectCheck(this.j,this.value)
    //       },
    export default {
        components: { SIdentify },
        data() {
            return {
                Value: 'EN',
                LoginName: '',
                Password: '',
                RnewPassword:'',
                login_cm_bj: {
                    backgroundImage: "url(" + require("@/assets/img/login-bg6.jpg") + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100%",
                    width: "100%",   
                    height:"100%",
                    opacity: "0.8",
                },
                forgetPwd:false,//忘记密码弹框
                identifyCodes: "1234567890",
                identifyCode: "",
                code:"",//text框输入的验证码
                useremail:"",//找回密码-电子邮箱地址
                usercode:"",//找回密码-验证码
                oldPassword: '',
                newPassword: '',
                RnewPassword: '',
                userName:'',
            }
        },
        created() {
            this.loginPage.Value = window.$.cookie('LanguagesTag')
            if (!this.loginPage.Value) {
                this.loginPage.Value = 'EN';
                this.LenChange()
            }
           
            if(this.$route.query.LoginStatus==0){
                self.$message.success(self.gets("Your account has been confirmed. Please try to login"))
            }
            this.refreshCode()

            console.log(this.$route.query.CusName)
            this.userName = this.$route.query.CusName
        },
        mounted(){
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        computed: {
             language() {
                return window.$.cookie('LanguagesTag')
                 
            },
            loginPage() {
                self = this;
                if (!self.$store.state.loginPage) {
                    var d = ToComponentData(LoginPage)
                    d.Value = 'CN'
                    self.$set(self.$store.state, "loginPage", d)
                }
                return self.$store.state.loginPage
            },
            ls() {
                window.rootVue = this;
                self = this;
                if (!self.$store.state.Languages) {
                    languageRequest.GetLanguages(function(d) {
                        self.$set(self.$store.state, "Languages", d)
                    })
                }
                return self.$store.state.Languages
            },
           
        },
        methods: {
           ChangeUserPassword() {
                var self = this;
                if (!self.userName) {
                    self.$message.error(self.gets("$请输入登录名"))
                    return
                }

                // if (!self.oldPassword) {
                //     self.$message.error(self.gets("$请输入旧密码"))
                //     return
                // }

                
                if (!self.newPassword) {
                    self.$message.error(self.gets("$请输入新密码"))
                    return
                }
                if (self.newPassword != self.RnewPassword) {
                    self.$message.error(self.gets("$密码不一致"))
                    return
                }

                

                userRequest.ResetUserPassword(function(d) {
                    if (d.Message == "OK") {
                       self.userName = "";
                        // self.oldPassword = "";
                        self.newPassword = "";
                        self.RnewPassword = "";
                        self.$message.success(self.gets("$操作成功"))
                        self.$router.push('/Customerlogin')
                    } else {
                       self.userName = "";
                        // self.oldPassword = "";
                        self.newPassword = "";
                        self.RnewPassword = "";
                        self.$message.error(d.Message)
                    }
                },self.userName, self.newPassword)
            },
            findPwd(){
                this.forgetPwd = true
            },
             //验证码
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            },
        
            refreshCode() {
                this.identifyCode = "";
                this.makeCode(this.identifyCodes, 4);
            },
            makeCode(o, l) {
                for (let i = 0; i < l; i++) {
                    this.identifyCode += this.identifyCodes[
                    this.randomNum(0, this.identifyCodes.length)
                    ];
                }
               
            },

            // 重置密码
            resetPwd(){
                if(this.useremail==""){
                    self.$message.error(self.gets("$请输入电子邮箱地址"))
                    return
                }
                var reg = /^.+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/
                if(!reg.test(this.useremail)){
                    self.$message.error(self.gets("$电子邮件格式不正确"))
                    return
                }
                
                this.forgetPwd = false
                self.$message.success(self.gets("$请注意查收邮件"))
                // self.$message.success(self.gets("$验证码对了！"))
            },
            toOurWeb(){
                window.location.href="http://service.shipping-revolution.com/"
            },
            gets(tag) {
                var d = gets(tag)
                return d;
            },
            Register() {
                self.$router.push('/Register')
            },
            LenChange() {


                window.$.cookie('LanguagesTag', this.loginPage.Value)
               
                    languageRequest.Change(function(d) {
                        window.location.reload()
                    }, this.loginPage.Value)
                
                
            },
            login() {

                this.$store.state.UserRights.Rights = [];
                window.ISGETRights = false;
                self = this;
                if (CheckByConfig(LoginPage, self.$store.state.loginPage)) {
                    userRequest.login(function(d) {
                        if (d.Message == "OK") {
                            self.$router.push('/Main/Index')
                        } else {
                            self.$message.error(d.Message);
                        }
                    }, ToSubmitData(this.$store.state.loginPage))
                }
            }
        }
    }
    var self;
</script>


<style>
    html {
        background-color: #F5F9FD;
        color: #666;
    }
    .resetPwd-form .el-form-item__content{
      display: flex;
    }
    /* .resetPwd-form .el-form--label-left .el-form-item__label{
      width: 90px !important;
    } */
    .item-width .el-form-item__label{
      width: 136px !important;
    }
.login-code{
    cursor: pointer;
    text-align: right;
    margin-bottom: 30px;
}
.forgetPWD{
    color:#409EFF;
    text-align:right;
    margin-bottom:20px;
    font-size:14px;
    cursor: pointer;
}
.s-canvas{
    height: 30px !important;
}
.login-container{
width:500px;
margin:auto;
    position: relative;
    margin-top: 0px !important;
    /* margin: 30px 0; */
   
   
    color: black;
}

    .login-opactiy{
    width:100%;
    height: 100%;
    position: absolute;
    top:0;
    z-index: -1;
    background: #fff;

      border: 0 solid rgba(120, 130, 140, 0.13);
    border-radius: 5px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    padding: 12px;
}
.login-container .login-form{
    padding: 20px 30px;
}
.login-container .login-form .title-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.login-container .login-logo-img{
    padding-top: 30px;
    text-align: center;
    width: 100%;
    cursor: pointer;
}
.login-container .login-logo-img img{
    width: 240px;
}

    .right {
        float: right;

    }
.lan .el-dropdown-selfdefine  span
{
  color:#000 !important;;
}
.customer-btn{
    text-align: center;
}
  
     .customerLogin{
           
            padding-left: 0px !important;
        }

</style>



// WEBPACK FOOTER //
// CustomerResetPwd.vue?14b21ae8